/**
 * Trash + restore — recover soft-deleted content items.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Trash, Loader2, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import "./studio.css";

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function StudioTrash() {
  const [items, setItems] = useState(null);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/api/studio/trash`, { withCredentials: true });
      setItems(r.data.items || []);
    } catch (_) { setItems([]); }
  };
  useEffect(() => { load(); }, []);

  const restore = async (id) => {
    try {
      await axios.post(`${API}/api/studio/content/restore/${id}`, {}, { withCredentials: true });
      toast.success("Restored");
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Restore failed");
    }
  };

  return (
    <>
      <Header />
      <div className="studio-shell">
        <Link to="/studio" className="studio-back" data-testid="trash-back">
          <ArrowLeft size={14}/> Back to Studio
        </Link>
        <div style={{ marginTop: 12 }}>
          <span className="studio-eyebrow"><Trash size={12}/> Trash</span>
          <h2 style={{ margin: "6px 0 18px" }}>Recently deleted videos</h2>
        </div>
        {items === null ? (
          <div className="studio-card studio-loading">
            <Loader2 size={22} className="ac-spin" style={{ color: "var(--st-purple, #a78bfa)" }}/>
          </div>
        ) : items.length === 0 ? (
          <div className="studio-card"><p className="studio-muted">Trash is empty.</p></div>
        ) : (
          <div className="studio-card">
            <ul className="studio-ops-list" data-testid="trash-list">
              {items.map((it) => (
                <li key={it._id} className="studio-ops-li" style={{ justifyContent: "space-between" }}>
                  <div>
                    <strong>{it.title}</strong>
                    <span>deleted {new Date(it.deleted_at).toLocaleString()}</span>
                  </div>
                  <button className="studio-btn-ghost" onClick={() => restore(it._id)} data-testid={`trash-restore-${it._id}`}>
                    <RotateCcw size={12}/> Restore
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}
